import type { PartnerColors } from '$lib/components/advertising/partners/types';

export function convertRgboObjectToRgba({ r, g, b, o }: PartnerColors) {
	return `rgba(${r},${g},${b},${o})`;
}
